module.exports = "/_next/static/images/77bf8119bfec50dc8f4f61ae7aed5bdc-girl-holding-phone@2x.jpg.webp";